import SurfModal from '@surf-turf/nemo/assets/extender-surf-modal'
import { enableBFCacheSupport } from './utils/bfcache'

const loadPage = () => {
  handleAllModals()
}

/**
 * Handle all modals.
 */
const handleAllModals = () => {
  const allOpenModalButtonElements = document.querySelectorAll('.js-open-modal')

  if (allOpenModalButtonElements.length > 0) {
    const baseModal = new SurfModal()

    allOpenModalButtonElements.forEach((openModalButtonElement) => {
      const targetId = openModalButtonElement
        ? openModalButtonElement.dataset.target
        : null

      const deeplinkTarget = openModalButtonElement
        ? openModalButtonElement.dataset.deeplinkTarget
        : null

      if (targetId) {
        // Add event listener for open modal trigger.
        openModalButtonElement.addEventListener('click', () => {
          baseModal.openModal(targetId, openModalButtonElement, deeplinkTarget)
        })
      }
    })
  }

  document.addEventListener('handleCloseModal', (event) => {
    const baseModal = new SurfModal()

    baseModal.closeModal(event.detail)
  })
}

enableBFCacheSupport()

document.addEventListener('DOMContentLoaded', loadPage)